import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-saved-dialog',
    templateUrl: './saved-dialog.component.html',
    styleUrls: ['./saved-dialog.component.scss'],
    standalone: false
})
export class SavedDialogComponent {
    @Input() open = false;
    @Output() closed = new EventEmitter<void>();

    close() {
        this.closed.emit();
    }
}
